<button mat-mini-fab class="debug" (click)="openUniversalSearchDialog($event)">
    <span class="material-symbols-rounded">code</span>
</button>
